<template>
  <div id="vue-app">
    <div
      data-swiftype-index="true"
      class="entry-content"
    >
      <!-- Document finder -->
      <section class="mtl">
        <div class="row mtl">
          <div class="large-24 columns">
            <PayRanges
              v-if="!loading"
              :jobs="jobs"
              :query="query"
            />
            <div
              v-if="loading"
              class="loading-icon ptxl center"
            >
              <i class="fas fa-spinner fa-spin fa-3x loadingdir" />
            </div>
          </div>
        </div>
      </section>
      <!-- Document finder -->
    </div> <!-- End .entry-content -->
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import PayRanges from './components/PayRanges.vue';
import { ClientTable } from 'vue-tables-2';
import moment from 'moment';

Vue.use(ClientTable, {
  options: {},
  useVuex: false,
  theme: 'bootstrap3',
  template: 'default',
});

export default {
  name: 'App',
  components: {
    PayRanges,
  },
  data () {
    return {
      api: {
        endpoint: process.env.VUE_APP_API_ENDPOINT,
      },
      jobs: [],
      query: null,
      loading: false,
    };
  },
  mounted () {
    let vm = this;
    vm.init();
  },
  methods: {
    getJobs () {
      let vm = this;
      return axios.get(vm.api.endpoint).then(async (result) => {
        result.data.rows.forEach( function(job) {
          job['pay_plan'] = vm.payPlanMap(job['family']);
          job['effective_date'] = moment.utc(job['start_date']);
        });
        vm.jobs = result.data.rows;
        return true;
      }).catch(() => {
        return false;
      });
    },
    async parseQuery () {
      let vm = this;
      vm.query = vm.$route.hash;
    },
    async init () {
      let vm = this;
      vm.loading = true;
      await vm.parseQuery();
      await vm.getJobs();
      vm.loading = false;
      await vm.scrollToDiv();
      vm.track();
    },
    async scrollToDiv() {
      let vm = this;
      let div = vm.$route.query.table.replace(/\s+/g, '-').toLowerCase();
      if ( div ) {
        let distance = document.getElementById(div).offsetTop;
        window.scrollTo({
          top: distance,
          behavior: 'smooth',
        });
      }
    },
    payPlanMap( family ) {
      switch( family ) {
      case '1':
        return 'AFSCME DC33 (0001-0025)';
      case '2':
        return 'AFSCME DC47 Local 2187 (EP01-EP41)';
      case '3':
        return 'Non-represented & AFSCME DC47 Local 2186 (N001-N041, CP10-13-A)';
      case '4':
        return 'Correctional (0038-0049A)';
      case '5':
        return 'Deputy Sheriff (0050-0059)';
      case '6':
        return 'Police (FOP) & Prosecution Detective (0201-0299)';
      case '7':
        return 'Fire (IAFF) (0301-0350)';
      case '8':
        return 'Hourly & Seasonal (H001-H020)';
      case '9':
        return 'Half-Time and Hourly Rates Physician & Dentist (EP19-EP40)';
      case '10':
        return 'Half-Time and Hourly Rates Physician & Dentist (N019-N040)';
      default:
        return '';
      }
    },
    track () {
      this.$gtag.event('view_item', {
        'event_category': 'ohr',
        'event_label': 'pay-ranges',
      });
    },
  },
};
</script>